import React, { useEffect, useRef } from 'react';

interface CollapsableProps {
    className?: string;
    open: boolean;
}

function Collapsible({ className, open, children }: React.PropsWithChildren<CollapsableProps>) {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current) {
            if (open) {
                ref.current.style.height = ref.current.scrollHeight + 'px';

                const element = ref.current;
                setTimeout(() => {
                    element.style.overflow = 'initial';
                }, 300); // Match the transition duration
            } else {
                ref.current.style.overflow = 'hidden';
                ref.current.style.height = '0px';
            }
        }

        // if (ref.current) {
        //     ref.current.style.height = open ? ref.current.scrollHeight + 'px' : '0px';
        // }
    }, [open]);

    return (
        <div
            ref={ref}
            className={className}
            style={{
                height: '0px',
                transition: 'height 0.3s',
            }}
        >
            {children}
        </div>
    );
}

export default Collapsible;
